// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 1536px) {
  :root {
    --nav-bar-height: 25px;
  }
}
`, "",{"version":3,"sources":["webpack://./public/css/responsive-2xl.css"],"names":[],"mappings":"AAAA;EACE;IACE,sBAAsB;EACxB;AACF","sourcesContent":["@media (min-width: 1536px) {\n  :root {\n    --nav-bar-height: 25px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
